import React, { memo } from 'react';
import { getAdditionalInfos } from '@/v2/helpers/additionalInfo/additionalInfoHelper';
import { TicketModel } from '@/v2/models/ticketModel';

type Props = {
  ticket: TicketModel;
};

const TicketAdditionalInfo = ({ ticket }: Props) => {
  if (!ticket?.additionalInfos) {
    return null;
  }
  const additionalInfo = getAdditionalInfos(ticket, true);
  if (additionalInfo.length) {
    return (
      <>
        <hr/>
        {additionalInfo}
      </>
    );
  }
  return null;
};

export default (memo(TicketAdditionalInfo));
